import type { ReactNode } from 'react'
import { JOURNEY_GUIDANCE, type JourneyGuidanceSurface } from '../domain/journeyGuidance'
import '../journey-guide.css'

interface PostOnboardingGuideProps {
  surface: JourneyGuidanceSurface
  status?: ReactNode
  collapsible?: boolean
}

function GuideBody({ surface, status, summaryLed = false }: Pick<PostOnboardingGuideProps, 'surface' | 'status'> & { summaryLed?: boolean }) {
  const guide = JOURNEY_GUIDANCE[surface]
  return <>
    <div className={`guide-introduction ${summaryLed ? 'is-summary-led' : ''}`}>
      {!summaryLed && <p className="eyebrow">{guide.eyebrow}</p>}
      {!summaryLed && <h2 id={`guide-${surface}-title`}>{guide.title}</h2>}
      <p>{guide.introduction}</p>
      {status}
    </div>
    <ol className="guide-steps">
      {guide.steps.map((step, index) => <li key={step.title}><span>{String(index + 1).padStart(2, '0')}</span><div><strong>{step.title}</strong><p>{step.detail}</p></div></li>)}
    </ol>
    <aside className="guide-origin"><strong>{guide.originTitle}</strong><p>{guide.origin}</p></aside>
  </>
}

export function PostOnboardingGuide({ surface, status, collapsible = false }: PostOnboardingGuideProps) {
  const guide = JOURNEY_GUIDANCE[surface]
  if (collapsible) return (
    <details className={`post-onboarding-guide is-collapsible guide-${surface}`}>
      <summary>
        <span><small>{guide.eyebrow}</small><strong>How this section works</strong><span>{guide.title}</span></span>
        <i aria-hidden="true">+</i>
      </summary>
      <div className="guide-expanded"><GuideBody surface={surface} status={status} summaryLed /></div>
    </details>
  )

  return (
    <section className={`post-onboarding-guide guide-${surface}`} aria-labelledby={`guide-${surface}-title`}>
      <GuideBody surface={surface} status={status} />
    </section>
  )
}
